import React, { useEffect } from 'react'
import { AlertContainer } from './Alert.styles'

interface AlertProps {
	children: React.ReactNode
	onClearError: () => any
}

export const Alert = ({ children, onClearError }: AlertProps): JSX.Element => {
	useEffect(() => {
		const reset = setTimeout(() => onClearError(), 3000)

		return () => clearTimeout(reset)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return <AlertContainer>{children}</AlertContainer>
}
